import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommercialData } from '../../model/users-model';

@Component({
  selector: 'scf-search-table',
  templateUrl: './search-table.component.html',
  styleUrls: ['./search-table.component.scss'],
})
export class SearchTableComponent implements OnInit {
  @Input() public searchType: number; //0: busqueda por usuario, 1: busqueda en arbol, 2: busqueda por comercial

  title: string;

  dataSource = new MatTableDataSource<CommercialData>();
  displayedColumns: string[] = ['user', 'userName', 'type', 'division', 'hostCode', 'activated', 'atributions'];
  hasPreviousKey: boolean = true;
  hasNextKey: boolean = true;
  totalOfRegisters: number;

  searchUserForm: FormGroup;

  constructor(private router: Router, private formBuilder: FormBuilder) {}

  ngOnInit() {
    switch (this.searchType) {
      case 0:
        this.title = 'Búsqueda de usuarios';
        this.searchUserForm = this.formBuilder.group({
          filterCriteria: [''],
        });
        break;
      case 1:
        this.title = 'Búsqueda en árbol';
        break;
      case 2:
        this.title = 'Búsqueda por comercial';
        break;
      default:
        break;
    }

    //TODO: LLAMAR AL SERVICIO DE TRAER LOS USUARIOS DEPENDIENDO DEL TIPO DE BUSUEDA
    this.dataSource.data = [
      {
        user: null,
        userName: 'pepito',
        type: 'autos',
        division: 'COMERCIAL EXTERNO',
        hostCode: '545640950AI',
        activated: 'N',
        atributions: [],
      },
      {
        user: 'pruebajuan',
        userName: 'juanito',
        type: 'consumo',
        division: 'COMERCIAL EXTERNO',
        hostCode: '545640950AI',
        activated: 'S',
        atributions: [
          '000',
          '001',
          '002',
          '003',
          '004',
          '005',
          '006',
          '007',
          '009',
          '010',
          '011',
          '013',
          '014',
          '101',
          '102',
          '103',
          '104',
          '105',
          '106',
          '107',
          '108',
          '109',
          '111',
          '112',
          '113',
          '114',
          '115',
          '125',
          '126',
          '127',
          '129',
          '201',
          '202',
          '203',
          '301',
          '302',
          '305',
          '306',
          '307',
          '308',
          '309',
          '401',
          '402',
          '403',
          '404',
          '405',
          '406',
          '501',
          '504',
          '600',
          '601',
          '602',
          '603',
          '604',
          '605',
          '606',
          '607',
          '608',
          '609',
          '610',
          '611',
          '612',
        ],
      },
      {
        user: null,
        userName: 'paquito',
        type: 'consumo',
        division: 'COMERCIAL INTERNO',
        hostCode: '545640950AI',
        activated: 'N',
        atributions: [],
      },
      {
        user: 'pruebakike',
        userName: 'kikito',
        type: 'autos',
        division: 'COMERCIAL INTERNO',
        hostCode: '545640950AI',
        activated: 'S',
        atributions: [],
      },
    ];
  }

  onClickEditData(element: CommercialData) {
    this.router.navigate(['/users/edit'], { state: { code: element.hostCode } });
  }

  onClickPreviousPage() {}

  onClickNextPage() {}

  searchSubordinates(element: CommercialData) {
    //IDEA: LO MEJOR ES SUSTITUIR LOS DATOS QUE TENEMOS POR UNOS NUEVOS, ASI NO HAY QUE REDIRIGIR
    //TODO: LLAMAR AL SERVICIO DE BUSCAR SUBORDINADOS
    this.dataSource.data = [
      {
        user: null,
        userName: 'pepita',
        type: 'autos',
        division: 'CADENA',
        hostCode: '545640950AI',
        activated: 'N',
        atributions: [],
      },
      {
        user: 'pruebajuana',
        userName: 'juanita',
        type: 'consumo',
        division: 'CADENA',
        hostCode: '545640950AI',
        activated: 'S',
        atributions: [
          '000',
          '001',
          '002',
          '003',
          '004',
          '005',
          '006',
          '007',
          '009',
          '010',
          '011',
          '013',
          '014',
          '101',
          '102',
          '103',
          '104',
          '105',
          '106',
          '107',
          '108',
          '109',
          '111',
          '112',
          '113',
          '114',
          '115',
          '125',
          '126',
          '127',
          '129',
          '201',
          '202',
          '203',
          '301',
          '302',
          '305',
          '306',
          '307',
          '308',
          '309',
          '401',
          '402',
          '403',
          '404',
          '405',
          '406',
          '501',
          '504',
          '600',
          '601',
          '602',
          '603',
          '604',
          '605',
          '606',
          '607',
          '608',
          '609',
          '610',
          '611',
          '612',
        ],
      },
      {
        user: null,
        userName: 'paquita',
        type: 'consumo',
        division: 'CADENA',
        hostCode: '545640950AI',
        activated: 'N',
        atributions: [],
      },
      {
        user: 'pruebakika',
        userName: 'kikita',
        type: 'autos',
        division: 'CADENA',
        hostCode: '545640950AI',
        activated: 'S',
        atributions: [],
      },
    ];
  }

  hasData() {
    return this.dataSource.data.length > 0 ? true : false;
  }

  filterUsers() {}
}
